import { Model } from "pinia-orm";
import Question from "@/models/Question";

export default class Choice extends Model {
  static entity = "choices";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      text: this.string(""),
      isCorrect: this.boolean(false),
      notation: this.number(0),
      order: this.number(null),
      question: this.string(""),
      questionData: this.belongsTo(Question, "question"),
    };
  }
}
